import script from "./QActsPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./QActsPublic.vue?vue&type=script&setup=true&lang=js"

import "./QActsPublic.vue?vue&type=style&index=0&id=62712df6&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62712df6"]])

export default __exports__